

































import Vue from 'vue'
import axios, { AxiosError } from 'axios'
import Component from 'vue-class-component'
import ManageContentForm from '../components/ManageContentForm.vue'
import { IModule } from '../types'
import { ICourse } from '../../courses/types'
import AddQuizModal from '../../quizzes/components/AddQuizModal.vue'
import { dispatchErrorMessage } from '../../core/utils'

interface INewQuizData {
  name: string,
  passMark: number,
  comments?: string
}

@Component({
  components: {
    ManageContentForm,
    AddQuizModal
  }
})
export default class Create extends Vue {
  data: IModule = {
    content: []
  }
  course: ICourse = {}

  loading = false

  showCreateQuiz = false
  courseId: number = 0
  moduleId: number = 0

  async mounted() {
    this.courseId = +this.$router.currentRoute.params.courseId
    this.moduleId = +this.$router.currentRoute.params.moduleId
    this.loading = true

    this.course = (await axios.get(`courses/${this.courseId}`)).data
    this.data = (await axios.get(`modules/${this.moduleId}`)).data
    this.loading = false
  }

  async submit(data: IModule) {
    this.loading = true
    try {
      const response = await axios.post(`modules/${this.moduleId}/content`, { content: data.content })
      this.loading = false
      this.$store.dispatch('showSuccess', 'Content updated successfully!')
      this.$router.go(-1)
    } catch (err) {
      this.loading = false
      this.displayError(err as AxiosError)
    }
  }

  quiz() {
    if (!this.data.quizId) {
      this.showCreateQuiz = true
    } else {
      this.$router.push('quiz/edit')
    }
  }

  async submitNewQuiz(data: INewQuizData) {
    try {
      await axios.post(`modules/${this.data.id}/quizzes`, data)
      this.showCreateQuiz = false
      this.$router.push('quiz/edit')
    } catch (err) {
      this.displayError(err)
    }
  }

  displayError(error: AxiosError<{ message: string }>) {
    dispatchErrorMessage(error, this.$store.dispatch)
  }
}
